// import { RouterModule, Routes } from "@angular/router";
// import { AuthGuard } from "src/app/core/guard/utility.guard";
// import { SecureZoneAuthoringToolsComponent } from "./authoring-tools/secure-zone-authoring-tools.component";
// import { DashboardComponent } from "./authoring-tools/dashboard/dashboard.component";
// import { ZoneSearchComponent } from "./zone-management/zone/zone-search/zone-search.component";
// import { EnvironmentSearchComponent } from "./zone-management/environment/environment-search/environment-search.component";
// import { ZoneCreateOrUpdateComponent } from "./zone-management/zone/zone-create-or-update/zone-create-or-update.component";
// import { EnvironmentCreateOrUpdateComponent } from "./zone-management/environment/environment-create-or-update/environment-create-or-update.component";

// export const secureZoneRoutes: Routes =[
//     {
//         path: 'secure-zone/auth-tools',
//         component: SecureZoneAuthoringToolsComponent,
//         canActivate: [AuthGuard],
//         children: [

//          {path:'', component:DashboardComponent},
//          {path:'zone/search', component:ZoneSearchComponent},
//          {path:'zone/create', component:ZoneCreateOrUpdateComponent,data: { create: true }},
//          {path:'zone/update/:zoneId', component:ZoneCreateOrUpdateComponent,data: { create: false }},
//          {path:'environment/search', component:EnvironmentSearchComponent},
//          {path:'environment/create', component:EnvironmentCreateOrUpdateComponent,data: { create: true }},
//          {path:'environment/update/:environmentId', component:EnvironmentCreateOrUpdateComponent,data: { create: false }}
         
//     ],
//       },
      
//   ];

//    export const secureZoneRouter = RouterModule.forChild(secureZoneRoutes);


import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/utility.guard";
import { SecureZoneAuthoringToolsComponent } from "./authoring-tools/secure-zone-authoring-tools.component";
import { SecurityZoneDashboardComponent } from "./authoring-tools/security-zone-dashboard/security-zone-dashboard.component";
import { ZoneSearchComponent } from "./zone-management/zone/zone-search/zone-search.component";
import { EnvironmentSearchComponent } from "./zone-management/environment/environment-search/environment-search.component";
import { ZoneCreateOrUpdateComponent } from "./zone-management/zone/zone-create-or-update/zone-create-or-update.component";
import { EnvironmentCreateOrUpdateComponent } from "./zone-management/environment/environment-create-or-update/environment-create-or-update.component";
import { PlatformSearchComponent } from "./zone-management/platform/platform-search/platform-search.component";
import { PlatformCreateOrUpdateComponent } from "./zone-management/platform/platform-create-or-update/platform-create-or-update.component";

export const secureZoneRoutes: Routes = [
  {
    path: 'secure-zone',
    component: SecureZoneAuthoringToolsComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', component: SecurityZoneDashboardComponent },

      { path: 'zone/search', component: ZoneSearchComponent },
      { path: 'zone/create', component: ZoneCreateOrUpdateComponent, data: { create: true } },
      { path: 'zone/update/:zoneId', component: ZoneCreateOrUpdateComponent, data: { create: false } },

      { path: 'environment/search', component: EnvironmentSearchComponent },
      { path: 'environment/create', component: EnvironmentCreateOrUpdateComponent, data: { create: true } },
      { path: 'environment/update/:environmentId', component: EnvironmentCreateOrUpdateComponent, data: { create: false } },
      { path: 'platform/search', component: PlatformSearchComponent },
      { path: 'platform/create', component: PlatformCreateOrUpdateComponent, data: { create: true } },
      { path: 'platform/update/:platformId', component: PlatformCreateOrUpdateComponent, data: { create: false } },

      {
  path: 'security-zone-management',
  loadChildren: () =>
    import('../shared-workflows/zone-management/zone-management.module')
      .then(m => m.ZoneManagementModule),
}
    ]
  }
];

   export const secureZoneRouter = RouterModule.forChild(secureZoneRoutes);